const VARIATION_ATTRIBUTE_NAME = 'data-ws-variation-id';

export default {
  VARIATION_ATTRIBUTE_NAME,
};
